export default __webpack_public_path__ + "static/media/eb-blk-3.af884dce.png";